const MellonWebECRTransactionType = Object.freeze({
    SALE: 0,
    REFUND: 1,
    PRE_AUTHORISATION: 2,
    PRE_AUTHORISATION_COMPLETION: 3,
    MAIL_ORDER_TELEPHONE_ORDER: 4,
    CASH_ADVANCE: 5,
    CARD_PAYMENT: 6,
    BILL_PAYMENT: 7,
    OTHER_PAYMENT: 8,
    PRE_PAYMENT: 9,
});

module.exports = MellonWebECRTransactionType;
